// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SubscriptionCard__root--wCaA {
    border-radius: 12px;
    border: 4px solid var(--obscure-color);
    background-color: var(--tertiary-color);
    padding: 20px 12px;
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    transition: 0.25s border-color ease-in-out;
    -webkit-tap-highlight-color: transparent;
}

    .SubscriptionCard__root--wCaA.SubscriptionCard__active--lnAf {
        --active-color: var(--main-color);

        border-color: var(--active-color);
    }

    .SubscriptionCard__root--wCaA.SubscriptionCard__active--lnAf .SubscriptionCard__checkbox--oOXa {
            border-color: var(--active-color);
        }

    .SubscriptionCard__root--wCaA.SubscriptionCard__active--lnAf .SubscriptionCard__popularBlock--mxJj,
        .SubscriptionCard__root--wCaA.SubscriptionCard__active--lnAf .SubscriptionCard__checkmark--lbOe {
            background-color: var(--active-color);
        }

    .SubscriptionCard__root--wCaA.SubscriptionCard__popular--p8iv {
        padding-top: 52px;
    }

.SubscriptionCard__popularBlock--mxJj {
    width: calc(100% + 8px);
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.01em;
    text-transform: uppercase;
    position: absolute;
    top: -4px;
    left: -4px;
    background-color: var(--main-color);
    border-radius: 8px 8px 0 0;
    color: var(--tertiary-color);
    transition: 0.25s background-color ease-in-out;
}

.SubscriptionCard__starIcon--c8Yt {
    width: 16px;
    height: 16px;
}

.SubscriptionCard__wrapper--Ysm5 {
    display: grid;
    grid-template-columns: 20px auto;
    grid-auto-rows: min-content;
    grid-gap: 8px;
}

.SubscriptionCard__planInformation--JH0J {
    display: flex;
    flex-direction: column;
}

.SubscriptionCard__name--j1Cl {
    color: var(--secondary-color);
    font-size: 19px;
    font-weight: 700;
    line-height: 24px;
    text-transform: uppercase;
}

.SubscriptionCard__secondaryWrapper--KSa2 {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
}

.SubscriptionCard__badge--mS3J {
    font-size: 14px;
    font-weight: 500;
    line-height: 12px;
    letter-spacing: 0.01em;
    color: var(--main-color);
    border: 1px solid currentColor;
    padding: 8px;
    border-radius: 26px;
}

.SubscriptionCard__checkbox--oOXa {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #D9D9D9;
    background-color: var(--tertiary-color);
    padding: 3px;
}

.SubscriptionCard__checkmark--lbOe {
    width: 100%;
    height: 100%;
    background-color: var(--dark-tertiary-new-color);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.SubscriptionCard__priceBlock--PSJC {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
    color: var(--secondary-color);
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
}

.SubscriptionCard__pricePerDayBlock--uxD7 {
    color: var(--secondary-color);
    text-align: center;
    display: flex;
    flex-direction: column;
    position: relative;
}

.SubscriptionCard__pricePerDayBlock--uxD7 .SubscriptionCard__value--TNuF {
        font-size: 19px;
        font-weight: 700;
        line-height: 24px;
    }

.SubscriptionCard__pricePerDayBlock--uxD7 .SubscriptionCard__label--Ip2R {
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
    }
`, "",{"version":3,"sources":["webpack://./src/ui/components/SubscriptionCard/SubscriptionCard.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,sCAAsC;IACtC,uCAAuC;IACvC,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,0CAA0C;IAC1C,wCAAwC;AAoB5C;;IAlBI;QACI,iCAAiC;;QAEjC,iCAAiC;IAUrC;;IARI;YACI,iCAAiC;QACrC;;IAEA;;YAEI,qCAAqC;QACzC;;IAGJ;QACI,iBAAiB;IACrB;;AAGJ;IACI,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,mCAAmC;IACnC,0BAA0B;IAC1B,4BAA4B;IAC5B,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,wBAAwB;IACxB,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,uCAAuC;IACvC,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gDAAgD;IAChD,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AAatB;;AAXI;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;;AAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB","sourcesContent":[".root {\n    border-radius: 12px;\n    border: 4px solid var(--obscure-color);\n    background-color: var(--tertiary-color);\n    padding: 20px 12px;\n    cursor: pointer;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 20px;\n    transition: 0.25s border-color ease-in-out;\n    -webkit-tap-highlight-color: transparent;\n\n    &.active {\n        --active-color: var(--main-color);\n\n        border-color: var(--active-color);\n\n        .checkbox {\n            border-color: var(--active-color);\n        }\n\n        .popularBlock,\n        .checkmark {\n            background-color: var(--active-color);\n        }\n    }\n\n    &.popular {\n        padding-top: 52px;\n    }\n}\n\n.popularBlock {\n    width: calc(100% + 8px);\n    height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    font-size: 12px;\n    font-weight: 500;\n    letter-spacing: 0.01em;\n    text-transform: uppercase;\n    position: absolute;\n    top: -4px;\n    left: -4px;\n    background-color: var(--main-color);\n    border-radius: 8px 8px 0 0;\n    color: var(--tertiary-color);\n    transition: 0.25s background-color ease-in-out;\n}\n\n.starIcon {\n    width: 16px;\n    height: 16px;\n}\n\n.wrapper {\n    display: grid;\n    grid-template-columns: 20px auto;\n    grid-auto-rows: min-content;\n    grid-gap: 8px;\n}\n\n.planInformation {\n    display: flex;\n    flex-direction: column;\n}\n\n.name {\n    color: var(--secondary-color);\n    font-size: 19px;\n    font-weight: 700;\n    line-height: 24px;\n    text-transform: uppercase;\n}\n\n.secondaryWrapper {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 8px;\n}\n\n.badge {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 12px;\n    letter-spacing: 0.01em;\n    color: var(--main-color);\n    border: 1px solid currentColor;\n    padding: 8px;\n    border-radius: 26px;\n}\n\n.checkbox {\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    border: 1px solid #D9D9D9;\n    background-color: var(--tertiary-color);\n    padding: 3px;\n}\n\n.checkmark {\n    width: 100%;\n    height: 100%;\n    background-color: var(--dark-tertiary-new-color);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.priceBlock {\n    display: inline-flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 4px;\n    color: var(--secondary-color);\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 18px;\n}\n\n.pricePerDayBlock {\n    color: var(--secondary-color);\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n\n    .value {\n        font-size: 19px;\n        font-weight: 700;\n        line-height: 24px;\n    }\n\n    .label {\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 18px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `SubscriptionCard__root--wCaA`,
	"active": `SubscriptionCard__active--lnAf`,
	"checkbox": `SubscriptionCard__checkbox--oOXa`,
	"popularBlock": `SubscriptionCard__popularBlock--mxJj`,
	"checkmark": `SubscriptionCard__checkmark--lbOe`,
	"popular": `SubscriptionCard__popular--p8iv`,
	"starIcon": `SubscriptionCard__starIcon--c8Yt`,
	"wrapper": `SubscriptionCard__wrapper--Ysm5`,
	"planInformation": `SubscriptionCard__planInformation--JH0J`,
	"name": `SubscriptionCard__name--j1Cl`,
	"secondaryWrapper": `SubscriptionCard__secondaryWrapper--KSa2`,
	"badge": `SubscriptionCard__badge--mS3J`,
	"priceBlock": `SubscriptionCard__priceBlock--PSJC`,
	"pricePerDayBlock": `SubscriptionCard__pricePerDayBlock--uxD7`,
	"value": `SubscriptionCard__value--TNuF`,
	"label": `SubscriptionCard__label--Ip2R`
};
export default ___CSS_LOADER_EXPORT___;
